export default __webpack_public_path__ + "static/media/slide-paga-servicio.a3cf37b7.png";